/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { FrameTextBlockData } from './FrameTextBlockData'
import {
  FrameTextBlockDataFromJSON,
  FrameTextBlockDataFromJSONTyped,
  FrameTextBlockDataToJSON,
} from './FrameTextBlockData'

/**
 *
 * @export
 * @interface FrameTextBlock
 */
export interface FrameTextBlock {
  /**
   *
   * @type {string}
   * @memberof FrameTextBlock
   */
  type: FrameTextBlockTypeEnum
  /**
   *
   * @type {FrameTextBlockData}
   * @memberof FrameTextBlock
   */
  data: FrameTextBlockData
}

/**
 * @export
 * @enum {string}
 */
export enum FrameTextBlockTypeEnum {
  FrameText = 'frame_text',
}

/**
 * Check if a given object implements the FrameTextBlock interface.
 */
export function instanceOfFrameTextBlock(
  value: object
): value is FrameTextBlock {
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function FrameTextBlockFromJSON(json: any): FrameTextBlock {
  return FrameTextBlockFromJSONTyped(json, false)
}

export function FrameTextBlockFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FrameTextBlock {
  if (json == null) {
    return json
  }
  return {
    type: json['type'],
    data: FrameTextBlockDataFromJSON(json['data']),
  }
}

export function FrameTextBlockToJSON(value?: FrameTextBlock | null): any {
  if (value == null) {
    return value
  }
  return {
    type: value['type'],
    data: FrameTextBlockDataToJSON(value['data']),
  }
}
